import React from 'react';
import PropTypes from 'prop-types';
import { ToggleOff, ToggleOn } from 'react-bootstrap-icons';
import './styles.scss';

function InputToggle({
  className = '',
  preText = '',
  isRequired = false,
  isDisabled = false,
  onChange,
  value = false,
  size = 32,
}) {
  const changeValue = () => {
    if (!isDisabled && onChange) {
      onChange(!value);
    }
  };

  return (
    <div className={`input_toggle ${isDisabled ? 'disabled' : ''} d-flex align-items-center ${className}`}>
      <div className='pre_text m-0'>
        {preText}
        {isRequired && <span className='is_required'>*</span>}
      </div>
      <div
        className={`toggle_option ms-3 p-0 ${value ? 'active' : ''}`}
        onClick={changeValue}
      >
        { value ? <ToggleOn size={size} /> : <ToggleOff size={size} /> }
      </div>
    </div>
  );
}

InputToggle.propTypes = {
  className: PropTypes.string,
  preText: PropTypes.string,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool,
  size: PropTypes.number,
};

export default InputToggle;
